





























import Vue from 'vue';
import Component from 'vue-class-component';
import { FileParseFormatService } from '../../service/FileParseFormatService';
import { DataGrid } from '@questelservices/common-vue';
import {
  DxColumn,
  DxEditing,
  DxDataGrid,
  DxForm,
  DxFormItem,
  DxHeaderFilter,
  DxLookup,
  DxPopup
} from 'devextreme-vue/data-grid';
import { DxItem, DxGroupItem, DxButtonItem } from 'devextreme-vue/form';
import { DxSelectBox, DxButton, DxTextBox, DxCheckBox } from 'devextreme-vue';
import DevExpress from 'devextreme/bundles/dx.all';
import CustomStore from 'devextreme/data/custom_store';
import FileParseFormatCreate from './file-parse-format-create.vue';
import { FileParseFormatDto } from '../../models/file-parsing/FileParseFormatDto';
import { FileParseFormatFileExtensionDto } from '../../models/file-parsing/FileParseFormatFileExtensionDto';

@Component({
  components: {
    DataGrid,
    DxColumn,
    DxEditing,
    DxDataGrid,
    DxForm,
    DxFormItem,
    DxHeaderFilter,
    DxItem,
    DxGroupItem,
    DxButtonItem,
    DxLookup,
    DxPopup,
    DxButton,
    DxTextBox,
    DxCheckBox,
    FileParseFormatCreate
  }
})
export default class FileParseFormatGrid extends Vue {
    dataGrid: any;
    fileParseFormatCustomStoreOptions: DevExpress.data.CustomStoreOptions;
    fileParseFormatService: FileParseFormatService;
   
    showFileParseFormatCreate: boolean = false;

    constructor() {
        super();
        this.fileParseFormatService = new FileParseFormatService();
        
        this.fileParseFormatCustomStoreOptions = {
          key: 'FileParseFormatId',
          load: loadOptions => this.fileParseFormatService.search(loadOptions),
        };
        
    }
 

    dataGridInitialized(e: any): void {
      this.dataGrid = e.component;
    }

    initNewRow(e: any) {
        e.promise = Promise.reject();
        this.showFileParseFormatCreate = true;
        return false;
    }    
    
    displayFileExtensions(format: FileParseFormatDto) {
        return format.FileExtensions.map(e => e.FileExtension).join(", ");
    }

    hidingFormatCreate() {
        this.showFileParseFormatCreate = false;        
    }
 }

